import {getTranslation} from "../../redMailTranslations";

interface ExtraDetailsYnetnewsProps {
    photographer: string
    sender: string
    mail: string
    phoneNumber: string
    validation: { mail: boolean, phoneNumber: boolean }
    onChange: (e: any) => void
    extraDetailsData: any
    lang: string
}

export class ExtraDetails extends React.Component<ExtraDetailsYnetnewsProps, State> {

    render() {
        const { photographer, sender, mail, phoneNumber, onChange, validation, extraDetailsData: { title, subTitle, mailPattern }, lang } = this.props

        return (
            <div className="RedMailExtraDetails">
                {title && <div className="ExtraDetailsTitle">{title}</div>}
                {subTitle && <div className="ExtraDetailsSubTitle">{subTitle}</div>}

                <div className="inputFieldWrapper">
                    <div className="inputField">
                        <input name="sender" dir="ltr" value={sender} onChange={(e) => onChange(e)} type="text" id="sender" placeholder={getTranslation(lang, "sender name")} ></input>
                    </div>
                    <div className="inputField">
                        <input name="photographer" dir="ltr" value={photographer} onChange={(e) => onChange(e)} type="text" id="photographer" placeholder={getTranslation(lang, "photo credit")} ></input>
                    </div>
                    <div className="inputField">
                        <input className={(phoneNumber && !validation.phoneNumber) ? "invalidInput" : ""} name="phoneNumber" dir="ltr" value={phoneNumber} onChange={(e) => onChange(e)} type="text" id="phoneNumber" placeholder={getTranslation(lang, "phone number")} ></input>
                        {(phoneNumber && !validation.phoneNumber) && <p className="redMail-error-validation">{getTranslation(lang, "phone validation text")}</p>}
                    </div>

                    <div className="inputField">
                        <input className={(mail && !validation.mail) ? "invalidInput" : ""} name="mail" dir="ltr" value={mail} onChange={(e) => onChange(e)} type="email" id="mail" placeholder={getTranslation(lang, "e-mail")} ></input>
                        {(mail && !validation.mail) && <p className="redMail-error-validation">{mailPattern}</p>}
                    </div>
                </div>
            </div>
        )
    }
}